// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"65689d44","329":"0508f524","535":"d15383e2","888":"b03fd1c9","922":"56a434c8","991":"27e8cd57"}[chunkId] + ".chunk.css";
};